module.exports = __webpack_public_path__ + "static/media/dentistry-white.4c6685a4.png";